import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=12a1169d&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"
import style0 from "./AddressDetails.vue?vue&type=style&index=0&id=12a1169d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1169d",
  null
  
)

export default component.exports